var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DespachoService } from '../../services/despacho.service';
import { CommonService } from '../../services/common.service';
import { KeycloakService } from '../../services/keycloak.service';
import { DespachoDiarioFilterComponent } from './despacho-diario-filter.component';
import { SearchService } from '../../services/search.service';
import { ActuacionPopupComponent } from '../actuacion/actuacion-popup.component';
import { SharedService } from '../../services/shared.service';
var DespachoDiarioComponent = (function () {
    function DespachoDiarioComponent(_http, _service, router, route, _desService, _comService) {
        this._http = _http;
        this._service = _service;
        this.router = router;
        this.route = route;
        this._desService = _desService;
        this._comService = _comService;
        this.activateList = false;
        this.activatePage = false;
        this.curPage = 0;
        this.searchFilter = {
            fecha_desde: "", fecha_hasta: "", org_id: 0, sec_id: 0, habil: false, favorito: false, caratula: "", tipoDoc: "", documento: "",
            usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10
        };
        this.cantResul = 10;
        this.busRapida = false;
    }
    DespachoDiarioComponent.prototype.ngOnInit = function () {
        var _this = this;
        // var date = new Date();
        // this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        // this.searchFilter.fecha_hasta = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        //this._subscription = SearchComponent.observable().subscribe(item => this.searchActionRap(item));
        this._subscription = DespachoDiarioFilterComponent.observable().subscribe(function (item) { return _this.searchAction(item); });
        this.route.queryParams.subscribe(function (param) {
            if (param['q']) {
                //console.log('param q');
                var filter = JSON.parse(atob(param['q']));
                _this.searchActionRap(filter);
            }
            else if (param['p']) {
                //console.log('param p');
                var filter = JSON.parse(atob(param['p']));
                _this.searchAction(filter);
            }
            else {
                _this._comService.emitBlocking(false);
            }
        });
    };
    DespachoDiarioComponent.prototype.ngOnDestroy = function () {
        // prevent memory leak when component is destroyed
        this._subscription.unsubscribe();
    };
    DespachoDiarioComponent.prototype.prevPage = function () {
        var _this = this;
        if (this.curPage > 0) {
            this._comService.emitBlocking(true);
            this.curPage = this.curPage - 1;
            this._desService.findDespachoPage(this.armarString(), this.curPage, 5).subscribe(function (response) {
                _this.despachoList = response;
                _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
                _this._comService.emitBlocking(false);
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
    };
    DespachoDiarioComponent.prototype.goToPage = function (index) {
        var _this = this;
        this.curPage = index;
        this._comService.emitBlocking(true);
        this._desService.findDespachoPage(this.armarString(), index + 1, 5).subscribe(function (response) {
            _this.despachoList = response;
            _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
            _this._comService.emitBlocking(false);
        }, function (error) {
            _this._comService.emitBlocking(false);
        });
    };
    DespachoDiarioComponent.prototype.goToLast = function () {
        var _this = this;
        if (this.curPage < this.pages.length - 1) {
            this._comService.emitBlocking(true);
            this.curPage = this.pages.length - 1;
            this._desService.findDespachoPage(this.armarString(), this.pages.length - 1, 5).subscribe(function (response) {
                _this.despachoList = response;
                _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
                _this._comService.emitBlocking(false);
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
    };
    DespachoDiarioComponent.prototype.goToFirst = function () {
        var _this = this;
        if (this.curPage > 0) {
            this._comService.emitBlocking(true);
            this.curPage = 0;
            this._desService.findDespachoPage(this.armarString(), 1, 5).subscribe(function (response) {
                _this.despachoList = response;
                _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
                _this._comService.emitBlocking(false);
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
    };
    DespachoDiarioComponent.prototype.nextPage = function () {
        var _this = this;
        if (this.curPage < this.pages.length - 1) {
            this._comService.emitBlocking(true);
            this.curPage = this.curPage + 1;
            this._desService.findDespachoPage(this.armarString(), this.curPage, 5).subscribe(function (response) {
                _this.despachoList = response;
                _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
                _this._comService.emitBlocking(false);
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
    };
    DespachoDiarioComponent.prototype.searchAction = function (filter) {
        var _this = this;
        //console.log('search action');
        this.hideErrorMsg();
        this.searchFilter = filter;
        this.curPage = 0;
        this._desService.findDespachoPage(this.armarString(), 1, 5).subscribe(function (response) {
            _this.despachoList = response;
            _this.pages = new Array(Math.ceil(_this.despachoList.total / _this.despachoList.size)).map(function (x, i) { return i; });
            _this.curPage = 0;
            _this.activatePage = true;
            _this.activateList = (_this.despachoList.total > 0);
            _this.busRapida = false;
            if (_this.despachoList.total === 0) {
                _this.showErrorMessage('No se han encontrado resultados');
            }
            _this._comService.emitBlocking(false);
        }, function (error) {
            _this._comService.emitBlocking(false);
        });
    };
    DespachoDiarioComponent.prototype.searchActionRap = function (fil) {
        var _this = this;
        this.hideErrorMsg();
        if (fil.query !== '') {
            this.filter = fil;
            //console.log('query ' + this.filter.query);
            this._service.findDespachos(this.filter.query).subscribe(function (response) {
                _this.despachoList = response;
                _this.activatePage = false;
                _this.curPage = 0;
                _this.activateList = (_this.despachoList.total > 0);
                _this.busRapida = true;
                if (_this.despachoList.total === 0) {
                    _this.showErrorMessage('No se han encontrado resultados');
                }
                _this._comService.emitBlocking(false);
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
        else {
            this._comService.emitBlocking(false);
        }
    };
    DespachoDiarioComponent.prototype.armarString = function () {
        this.searchFilter.page = this.curPage;
        this.searchFilter.size = this.cantResul;
        this.strParam = btoa(SharedService.unescape(encodeURIComponent(JSON.stringify(this.searchFilter))));
        return this.strParam;
    };
    DespachoDiarioComponent.prototype.onChangeDate = function (select) {
        this.searchFilter.fecha_hasta = this.searchFilter.fecha_desde;
    };
    DespachoDiarioComponent.prototype.onClickShowActPopup = function (id) {
        this.actPopup.loadAct(id);
    };
    // onChangePages(selected: number): void {
    //     this.cantResul = selected;
    //     if (selected > 0) {
    //         this.curPage = 0;
    //         this.onClickSearch();
    //     } else {
    //         if (this.selectedCir != 0 && this.searchFilter.fecha_desde != "" && this.searchFilter.fecha_hasta != null) {
    //             this._desService.findDespachoAll(this.armarString()).subscribe(response => {
    //                 this.despachoList = response;
    //                 this.activatePage = false;
    //                 this.activateList = (this.despachoList.total > 0);
    //                 if (this.despachoList.total == 0) {
    //                     this.showErrorMessage("No se han encontrado resultados");
    //                 }
    //             });
    //         } else {
    //             this.showErrorMessage("Los filtros Fecha Desde/Hasta son obligatorios");
    //         }
    //     }
    // }
    DespachoDiarioComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    DespachoDiarioComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    // export(): string {
    //     return this._desService.urlSer() + "despacho/exportar";
    // }
    DespachoDiarioComponent.prototype.clickExport = function () {
        var _this = this;
        var that = this;
        //this._comService.emitBlocking(true);
        if (this.busRapida) {
            this.export(this.despachoList.data);
        }
        else {
            var fileName = "despacho_exportar.xls";
            var a = document.createElement("a");
            document.body.appendChild(a);
            this._desService.exportAll(this.armarString()).subscribe(function (response) {
                var file = new Blob([response], { type: 'application/xls' });
                var fileURL = window.URL.createObjectURL(file);
                _this._comService.emitBlocking(false);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            }, function (error) {
                _this._comService.emitBlocking(false);
            });
        }
    };
    DespachoDiarioComponent.prototype.export = function (list) {
        //console.log("Export " + JSON.stringify(list));
        var that = this;
        var fileName = "despacho_exportar.xls";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._desService.export(JSON.stringify(list)).subscribe(function (response) {
            var file = new Blob([response], { type: 'application/xls' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        });
    };
    DespachoDiarioComponent.prototype.getClassItem = function (i) {
        var classes = "page-item";
        if (this.curPage == i) {
            classes = "active " + classes;
        }
        return classes;
    };
    return DespachoDiarioComponent;
}());
__decorate([
    ViewChild(ActuacionPopupComponent),
    __metadata("design:type", ActuacionPopupComponent)
], DespachoDiarioComponent.prototype, "actPopup", void 0);
DespachoDiarioComponent = __decorate([
    Component({
        //selector: 'despacho-diario-component',
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'despacho-diario.component.html'
    }),
    __metadata("design:paramtypes", [Http,
        SearchService,
        Router,
        ActivatedRoute,
        DespachoService,
        CommonService])
], DespachoDiarioComponent);
export { DespachoDiarioComponent };
//# sourceMappingURL=despacho-diario.component.js.map